<template>
  <div class="about-page">
    <SubPageHeader title="关于我们" />
    <div class="content">
      <img :src="partyLogo" class="party-logo" alt="党徽图标" />
      <div class="info-block">
        <p class="line">版本信息</p>
        <p class="line">天翼党建（VR版）</p>
        <p class="line">Version 2.0</p>
        <p class="line">版权所有：国脉文化党委</p>
        <p class="line">上线日期：2024.01.31</p>
      </div>
      <button class="manual-btn" type="button" @click="goManualPage">使用手册</button>
    </div>
  </div>
</template>

<script>
import SubPageHeader from '../component/SubPageHeader.vue';
import partyLogo from '@/assets/img/mine/party.jpg';

export default {
  name: 'AboutPage',
  components: {
    SubPageHeader
  },
  data() {
    return {
      partyLogo
    };
  },
  methods: {
    goManualPage() {
      this.$router.push('/mine/manual');
    }
  }
};
</script>

<style scoped lang="scss">
.about-page {
  min-height: 100vh;
  background: #ffffff;
}

.content {
  padding-top: 13.84615vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.party-logo {
  width: 18vw;
  height: 18vw;
  object-fit: contain;
}

.info-block {
  margin-top: 9.23077vw;
  text-align: center;
}

.line {
  margin: 0;
  color: #001a43;
  line-height: 1.8;
}

.line:nth-child(1) {
  font-size: 7vw;
  font-weight: 600;
}

.line:nth-child(2) {
  font-size: 6vw;
  font-weight: 600;
}

.line:nth-child(3) {
  font-size: 6vw;
  font-weight: 600;
}

.line:nth-child(4),
.line:nth-child(5) {
  font-size: 5vw;
}

.manual-btn {
  margin-top: 33.33333vw;
  width: 30.76923vw;
  height: 10.25641vw;
  border: 0.25641vw solid #9e9e9e;
  border-radius: 1.02564vw;
  background: #ffffff;
  color: #4d4d4d;
  font-size: 5.12821vw;
}
</style>
